import { parsePhoneNumberFromString } from 'libphonenumber-js';

export const formatMobileNumber = mobileNumber => {
  if (!mobileNumber) return null;
  const phone = parsePhoneNumberFromString(mobileNumber, 'US');
  return phone?.format('E.164') || null;
};

export const isValidMobileNumber = mobileNumber => {
  if (!mobileNumber) return false;

  const phone = parsePhoneNumberFromString(mobileNumber, 'US');
  return phone?.isValid() || false;
};

export const removeCountryCode = mobileNumber => {
  if (!mobileNumber) return null;

  const phone = parsePhoneNumberFromString(mobileNumber, 'US');

  if (!phone) return null;

  return phone.nationalNumber;
};

export const formatMobileNumberForDisplay = mobileNumber => {
  if (!mobileNumber) {
    return '';
  }

  const cleaned = mobileNumber.replace(/\D/g, '');

  // Format as +1 (XXX) ***-****
  if (cleaned.length === 11) {
    return `+${cleaned.charAt(0)} (${cleaned.substring(1, 4)}) ***-****`;
  }

  return mobileNumber;
};
